
import { FormGroup } from '@angular/forms';

export function CustomDateValidator(controlName: string) {
    return (formGroup: FormGroup) => {
        const control = formGroup.controls[controlName];

        if (control.status === 'VALID') {
            control.setErrors(null);
        } else {
            control.setErrors({ invalidDate: true });
        }

    }
}
